module.exports = __webpack_public_path__ + "img/sync_success.png?32880b52";